export default __webpack_public_path__ + "static/media/character_thumbail4.652e8ca1.png";